<template>
  <v-btn
    @click="traduccionesDialog = true"
    color="primary"
    small
    outlined
    class="mx-4"
    >Traducir
    <v-dialog
      max-width="800"
      v-model="traduccionesDialog"
      :persistent="loading"
    >
      <v-card flat>
        <v-card-title> Traducir</v-card-title>
        <v-card-actions>
          <v-btn color="secondary" outlined @click="traduccionesDialog = false"
            >Cerrar</v-btn
          >
          <v-spacer />
          <v-btn color="primary" @click="traducir" :loading="loading"
            >Traducir</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-list>
            <v-list-item-group
              v-model="traduccionSeleccionada"
              multiple
              active-class=""
            >
              <v-list-item
                :value="cadena.key"
                v-for="(cadena, i) in datosComputed"
                :key="`cadena_${i}`"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ cadena.key }}</v-list-item-title>
                    <v-list-item-subtitle
                      v-if="!!cadena.texto && !!cadena.texto[0]"
                      >{{ cadena.texto[0].text }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
export default {
  props: {
    datos: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  data: () => {
    return {
      loading: false,
      traduccionSeleccionada: [],
    };
  },
  computed: {
    traduccionesDialog: {
      get() {
        return this.$store.state.traduccionesDialog;
      },
      set(v) {
        this.$store.commit("SET_TRADUCCIONES_DIALOG", v);
      },
    },
    datosComputed() {
      return this.datos.map((t) => {
        return t;
      });
    },
  },
  methods: {
    traducir() {
      this.loading = true;
      this.$store
        .dispatch(
          "traducir",
          this.datosComputed.filter((d) =>
            this.traduccionSeleccionada.includes(d.key)
          )
        )
        .then((r) => {
          console.log(r);
          this.$emit("camposTraducidos", r);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>